module.exports = __webpack_public_path__ + "img/oaks-nest-bathroom-1.9c23e69e.jpeg";